<!--
  - Copyright (c) 2019 Eva Novotná, Juraj Šimon
  -->
<template>
  <diV>
    <div class="main-title right is-uppercase">{{ $t("contact me") }}</div>
    <div class="contact-me-section">
      <div class="with-padding">
        <div class="section-sub-title contact-item">Eva Novotná</div>
        <div class="columns">
          <div class="contact-type column is-narrow">Email</div>
          <div class="contact-text column is-narrow">
            <a href="mailto:eva@novotna.test">eva@novotna.test</a>
          </div>
        </div>
        <div class="columns">
          <div class="contact-type column is-narrow">{{ $t("Mobile") }}</div>
          <div class="contact-text column is-narrow">777123456</div>
        </div>
        <div class="columns">
          <div class="contact-type column is-narrow">Facebook</div>
          <div class="contact-text column is-narrow">
            <a href="mailto:eva@novotna.test">eva.novotna</a>
          </div>
        </div>
      </div>
    </div>
  </diV>
</template>
<script>
// import fbIcon from "./../assets/facebook.svg";
// import phoneIcon from "./../assets/mobile-phone-2.svg";
// import mailIcon from "./../assets/at.svg";
export default {
  // components: {
  //   fbIcon,
  //   phoneIcon,
  //   mailIcon
  // }
};
</script>
<style lang="scss" scoped>
@import "./../styles/main";
@import "section";

.contact-me-section {
  @extend .page-section;
  background-color: $section-background-color;

  .contact-row {
  }

  .contact-type {
    font-size: 2em;
    line-height: 1em;
    font-weight: bold;
  }

  .contact-text {
    margin-left: 1rem;
    font-size: 2rem;
    line-height: 2rem;
  }
}
</style>
